import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="keep-checkbox"
export default class extends Controller {
  static targets = ['checkbox', 'submitButton', 'count', 'credit', 'optionalCompulsory', 'specialized']
  static values = {
    enable: Boolean,
    sessionClearFlag: Boolean,
    storageKey: String,
    countFlag: Boolean,
    creditFlag: Boolean,
    courseCreditUrl: String,
    maxCredit: Number,
    juniorCollegeFlag: Boolean
  }

  initialize() {
    if (this.sessionClearFlagValue) {
      this.sessionClear()
    }
    this.checkedInitialDisplay()
    this.propDisabled()
    this.element[this.identifier] = this;
    if(this.countFlagValue) {
      this.getCourseCountLength()
    }
    if(this.creditFlagValue) {
      this.getCourseCountCredit()
    }
  }

  checkedInitialDisplay() {
    const storageValues = this.getAlreadyCheckValues()
    const checkBoxList = this.checkboxTargets
    if (storageValues) {
      for (const storageValue of storageValues) {
        const checkBox = checkBoxList.find(element => Number(element.value) == storageValue)
        if (checkBox) {
          checkBox.checked = true
        }
      }
    }
  }

  changeDisabledButton(event) {
    this.updateStorage(event)
    this.propDisabled()
    if(this.countFlagValue) {
      this.getCourseCountLength()
    }
    if(this.creditFlagValue) {
      this.getCourseCountCredit()
    }
  }

  judgeChecked() {
    if (
      sessionStorage.getItem(this.storageKeyValue) &&
      sessionStorage.getItem(this.storageKeyValue).replace('[', '').replace(']', '')
    ) {
      this.enableValue = true
    } else {
      this.enableValue = false
    }
  }

  propDisabled() {
    this.judgeChecked()
    this.submitButtonTargets.forEach(element => {
      element.disabled = !this.enableValue
    })
  }

  // チェックボックス押下時のsessionStorageへの登録、削除
  updateStorage(event) {
    const selectedValue = Number(event.target.value)
    if (event.target.checked) { // チェックを入れた場合
      this.addStorageValues([selectedValue])
    } else { // チェックを外した場合
      const removeArray = this.getAlreadyCheckValues().filter(element => { return element != selectedValue })
      if (removeArray.length) {
        sessionStorage.setItem(this.storageKeyValue, JSON.stringify(removeArray))
      } else {
        this.sessionClear()
      }
    }
  }

  addStorageValues(values) {
    const alreadySelectedValues = this.getAlreadyCheckValues()
    if (alreadySelectedValues) {
      // 既存の配列に選択した値を結合
      const joinedSelectedArea = alreadySelectedValues.concat(values)
      sessionStorage.setItem(this.storageKeyValue, JSON.stringify(joinedSelectedArea))
    } else {
      sessionStorage.setItem(this.storageKeyValue, JSON.stringify(values))
    }
  }

  submitSettingForm(event) {
    event.preventDefault()
    // buttonタグの中のspanタグがevent.targetとして返ることがあるのでボタンタグを取得
    const button = (event.target.tagName === 'BUTTON') ? event.target : event.target.closest('button')

    if (button.getAttribute('data-message')) {
      if (!confirm(button.getAttribute('data-message'))) {
        return
      }
    }

    button.form.elements['ids'].value = this.getAlreadyCheckValues()
    button.form.submit()
    button.disabled = true
  }

  sessionClear() {
    sessionStorage.removeItem(this.storageKeyValue)
  }

  getAlreadyCheckValues() {
    // sessionStorageに保存している値の配列
    return JSON.parse(sessionStorage.getItem(this.storageKeyValue))
  }

  checkFromStorage() {
    const storageValues = this.getAlreadyCheckValues()
    const checkboxList = this.checkboxTargets
    for (const checkbox of checkboxList) {
      if (storageValues) {
        if (storageValues.includes(Number(checkbox.value))) {
          checkbox.checked = true
        }
      } else {
        checkbox.checked = false
      }
      this.propDisabled()
    }
  }

  getCourseCountLength() {
    if(this.getAlreadyCheckValues() == null) {
      this.countTarget.innerHTML = "0科目"
    } else {
      const count = this.getAlreadyCheckValues().length
      this.countTarget.innerHTML = String(count) + "科目"
    }
  }

  getCourseCountCredit() {
    if(this.getAlreadyCheckValues() == null) {
      this.creditTarget.innerHTML = this.creditTarget.innerHTML.replace(/現在選択中の単位合計 [0-9]{1,}/, '現在選択中の単位合計 0')
      if(this.juniorCollegeFlagValue) {
        this.specializedTarget.innerHTML = this.specializedTarget.innerHTML.replace(/専門科目Ⅱの中からあと [0-9]{1,}/, '専門科目Ⅱの中からあと 20')
      } else {
        this.optionalCompulsoryTarget.innerHTML = this.optionalCompulsoryTarget.innerHTML.replace(/第二類選択必修科目の中からあと [0-9]{1,}/, '第二類選択必修科目の中からあと 18')
      }
    } else {
      const query = new URLSearchParams()
      query.set('ids', this.getAlreadyCheckValues())
      fetch(`${this.courseCreditUrlValue}?${query}`)
        .then(response => response.json())
        .then(data => {
          this.creditTarget.innerHTML = this.creditTarget.innerHTML.replace(/現在選択中の単位合計 [0-9]{1,}/, `現在選択中の単位合計 ${data['text']}`)
          if(this.juniorCollegeFlagValue) {
            const specialized_credit = this.maxCreditValue - Number(data['specialized'])
            this.specializedTarget.innerHTML = this.specializedTarget.innerHTML.replace(/専門科目Ⅱの中からあと [0-9]{1,}/, `専門科目Ⅱの中からあと ${specialized_credit}`)
          } else {
            const optional_credit = this.maxCreditValue - Number(data['optional'])
            this.optionalCompulsoryTarget.innerHTML = this.optionalCompulsoryTarget.innerHTML.replace(/第二類選択必修科目の中からあと [0-9]{1,}/, `第二類選択必修科目の中からあと ${optional_credit}`)
          }
        })
    }
  }
}
